import type { CoreProductAvailabilityResponseSingle, ParameterID } from '@flecto/types'

import { api } from '../../../services/api'

/**
 * Checks product availability for booking.
 *
 * @endpoint GET /api/saas/me/products/{productId}/availability
 * @scope saas
 * @see https://flecto.dev/api-4724230
 */
export async function getProductAvailabilityById(
  productId: ParameterID,
  options: GetProductAvailabilityByIdOptions
): Promise<CoreProductAvailabilityResponseSingle> {
  const { data } = await api.get<CoreProductAvailabilityResponseSingle>(
    `/api/saas/me/products/${productId}/availability`,
    {
      params: options,
    }
  )

  return data
}

export type GetProductAvailabilityByIdOptions = {
  start_at: string
  end_at: string
  quantity?: number
  ignore_booking_ids?: number[]
  context_booking_id?: ParameterID
}
